import React, { useState } from 'react';
import ClientSidebar from '../ClientSidebar';
import ClientBottomNav from '../ClientBottomNav';

const ClientPageLayout = ({ children, title = "Client Dashboard" }) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 pb-16 lg:pb-0">
      <div className="page-container py-4 sm:py-6 md:py-8 px-4 sm:px-6">
        {/* Page Title */}
        <div className="mb-4 sm:mb-6 md:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-black">{title}</h1>
        </div>
        
        {/* Two-column layout: Sidebar + Main Content */}
        <div className="flex flex-col lg:flex-row gap-3 sm:gap-4">
          {/* Left Sidebar */}
          <ClientSidebar 
            isMobileOpen={isMobileSidebarOpen}
            onClose={() => setIsMobileSidebarOpen(false)}
          />

          {/* Right Main Content */}
          <div className="flex-1 w-full">
            {children}
          </div>
        </div>
      </div>
      
      {/* Mobile Bottom Navigation */}
      <ClientBottomNav />
    </div>
  );
};

export default ClientPageLayout;
